import { useEffect, useMemo, useState } from 'react'

import { filterServiceCalibCatalogForRobotType } from './catalogItemActions'
import { fetchServiceCalibSourceRows } from './serviceCalibApi'
import type { ServiceCalibCatalogData } from './serviceCalibTypes'
import { buildServiceCalibCatalog } from './serviceCalibUtils'

export function useServiceCalibCatalog(facilityId: number | null | undefined, robotType?: string | null) {
  const [catalog, setCatalog] = useState<ServiceCalibCatalogData | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (facilityId == null) {
      setCatalog(null)
      setLoading(false)
      setError(null)
      return
    }

    let cancelled = false
    setLoading(true)
    setError(null)

    fetchServiceCalibSourceRows(facilityId)
      .then(({ lots, maintenancePoints, stations }) => {
        if (cancelled) {
          return
        }
        setCatalog(buildServiceCalibCatalog(lots, maintenancePoints, stations))
      })
      .catch(err => {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : 'Failed to load service points')
          setCatalog(null)
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false)
        }
      })

    return () => {
      cancelled = true
    }
  }, [facilityId])

  const filteredCatalog = useMemo(
    () => (catalog ? filterServiceCalibCatalogForRobotType(catalog, robotType) : null),
    [catalog, robotType]
  )

  return { catalog: filteredCatalog, loading, error }
}
